/*!
 * Ticket à gratter pour popups Klaviyo — v1.3
 *
 * OÙ L'INSTALLER : sur le site, PAS dans le bloc HTML Klaviyo (Klaviyo y
 * supprime tous les <script>).
 *   - Shopify : Boutique en ligne → Thèmes → Modifier le code → theme.liquid,
 *     juste avant </body>. (Pas dans « Événements clients / Custom pixel » :
 *     ce bac à sable n'a pas accès à la page.)
 *   - Google Tag Manager : balise « HTML personnalisé », déclencheur « All Pages ».
 *   - Autre CMS : n'importe quel emplacement « script global / footer ».
 *
 * CE QU'IL FAIT : il repère chaque .ks-card dès que Klaviyo affiche la popup,
 * pose par-dessus un calque grattable (souris + doigt), mesure la surface
 * grattée, révèle le texte caché au-delà du seuil, puis affiche le bouton
 * portant la classe .ks-claim (plusieurs éléments possibles).
 *
 * RÉGLAGES : définissez window.KS_SCRATCH_CONFIG = { threshold: 0.6, ... }
 * avant ce script, ou modifiez DEFAULTS ci-dessous.
 */
(function () {
  'use strict';
  if (window.KsScratch) return;

  var DEFAULTS = {
    selector: '.ks-card',
    claimSelector: '.ks-claim',  // élément(s) masqué(s) jusqu'au grattage
    threshold: 0.3,      // part de la surface à gratter avant révélation (0 à 1)
    brush: 0.09,         // rayon du grattoir, en fraction du plus petit côté de la carte
    minBrush: 16,        // rayon minimum en px
    mouseHover: true,    // à la souris : gratte au simple survol (sans cliquer)
    dust: true,          // copeaux qui tombent pendant le grattage
    confetti: true,      // confettis à la révélation
    coinCursor: true,    // curseur « pièce » sur ordinateur
    sheen: 'auto',       // reflet qui invite à gratter : 'auto' (selon le design), true ou false
    fontsUrl: '',        // feuille Google Fonts à charger pour les libellés (optionnel)
    a11yLabel: 'Reveal my offer'
  };

  var CONFIG = {};
  var user = window.KS_SCRATCH_CONFIG || {};
  for (var k in DEFAULTS) CONFIG[k] = user.hasOwnProperty(k) ? user[k] : DEFAULTS[k];

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var THEME_NAMES = ['gold', 'holo', 'silver', 'coin', 'noir', 'pop', 'gilt', 'flakes', 'silk', 'medal', 'pearl', 'botanic'];
  /* Effets propres à certains designs : reflet d'invitation, copeaux et confettis en feuille d'or */
  var FX = {
    gilt: { sheen: true, leaf: true },
    flakes: { sheen: true, leaf: true },
    silk: { sheen: true, leaf: true },
    medal: { sheen: true, leaf: true },
    pearl: { sheen: true },
    botanic: { sheen: true, leaf: true }
  };
  var TAU = Math.PI * 2;
  var live = [];
  var revealedKeys = {};

  /* ---------------------------------------------------------------------
     Utilitaires
     --------------------------------------------------------------------- */

  function rng(seed) {
    var s = seed >>> 0 || 1;
    return function () {
      s ^= s << 13; s >>>= 0;
      s ^= s >>> 17;
      s ^= s << 5; s >>>= 0;
      return s / 4294967296;
    };
  }

  var probe = null;
  function rgba(color, alpha) {
    if (!probe) probe = document.createElement('canvas').getContext('2d');
    probe.fillStyle = '#000';
    probe.fillStyle = color;
    var c = probe.fillStyle, r, g, b;
    if (c.charAt(0) === '#') {
      r = parseInt(c.substr(1, 2), 16); g = parseInt(c.substr(3, 2), 16); b = parseInt(c.substr(5, 2), 16);
    } else {
      var m = c.match(/[\d.]+/g) || [0, 0, 0];
      r = +m[0]; g = +m[1]; b = +m[2];
    }
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
  }

  var noiseTile = null;
  function grain(ctx, inst, alpha, mode) {
    if (!noiseTile) {
      noiseTile = document.createElement('canvas');
      noiseTile.width = noiseTile.height = 128;
      var nx = noiseTile.getContext('2d'), img = nx.createImageData(128, 128), d = img.data, r = rng(7);
      for (var i = 0; i < d.length; i += 4) {
        var v = (r() * 255) | 0;
        d[i] = d[i + 1] = d[i + 2] = v;
        d[i + 3] = 255;
      }
      nx.putImageData(img, 0, 0);
    }
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalAlpha = alpha;
    ctx.globalCompositeOperation = mode || 'overlay';
    ctx.fillStyle = ctx.createPattern(noiseTile, 'repeat');
    ctx.fillRect(0, 0, inst.canvas.width, inst.canvas.height);
    ctx.restore();
  }

  function roundRect(ctx, x, y, w, h, r) {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function innerEdge(ctx, w, h, radius, color) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    roundRect(ctx, 0.75, 0.75, w - 1.5, h - 1.5, radius);
    ctx.stroke();
    ctx.restore();
  }

  function star4(ctx, x, y, s, color) {
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(x, y - s);
    ctx.quadraticCurveTo(x, y, x + s, y);
    ctx.quadraticCurveTo(x, y, x, y + s);
    ctx.quadraticCurveTo(x, y, x - s, y);
    ctx.quadraticCurveTo(x, y, x, y - s);
    ctx.fill();
  }

  function star5(ctx, cx, cy, outer, inner) {
    ctx.beginPath();
    for (var i = 0; i < 10; i++) {
      var rad = i % 2 ? inner : outer, a = -Math.PI / 2 + i * Math.PI / 5;
      ctx[i ? 'lineTo' : 'moveTo'](cx + Math.cos(a) * rad, cy + Math.sin(a) * rad);
    }
    ctx.closePath();
  }

  /* Texte avec interlettrage (canvas n'applique pas letter-spacing partout) */
  function textWidth(ctx, text, spacing) {
    return ctx.measureText(text).width + spacing * Math.max(0, text.length - 1);
  }

  function spaced(ctx, text, cx, baseline, spacing) {
    ctx.textAlign = 'left';
    var x = cx - textWidth(ctx, text, spacing) / 2;
    if (!spacing) { ctx.fillText(text, x, baseline); return; }
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      ctx.fillText(ch, x, baseline);
      x += ctx.measureText(ch).width + spacing;
    }
  }

  /* Dessine le libellé centré en (cx, cy), réduit pour tenir dans maxW. */
  function label(ctx, s, cx, cy, o) {
    var size = o.maxSize, fs = s.fontStyle || '';
    ctx.font = fs + s.weight + ' ' + size + 'px ' + s.family;
    var wdt = textWidth(ctx, s.text, s.spacing * size);
    if (wdt > o.maxW) {
      size = size * o.maxW / wdt;
      ctx.font = fs + s.weight + ' ' + size + 'px ' + s.family;
      wdt = textWidth(ctx, s.text, s.spacing * size);
    }
    var sp = s.spacing * size;
    var m = ctx.measureText(s.text);
    var asc = m.actualBoundingBoxAscent || size * 0.7;
    var desc = m.actualBoundingBoxDescent || 0;
    var base = cy + (asc - desc) / 2;
    ctx.textBaseline = 'alphabetic';
    if (o.shadow) { ctx.fillStyle = o.shadow; spaced(ctx, s.text, cx + (o.shadowX || 0), base + (o.shadowY || Math.max(1, size * 0.05)), sp); }
    if (o.highlight) { ctx.fillStyle = o.highlight; spaced(ctx, s.text, cx, base - Math.max(0.6, size * 0.03), sp); }
    if (o.glow) {
      ctx.save();
      ctx.shadowColor = o.glow;
      ctx.shadowBlur = o.glowBlur || 8;
      ctx.fillStyle = o.fill || s.label;
      spaced(ctx, s.text, cx, base, sp);
      ctx.restore();
    }
    ctx.fillStyle = o.fill || s.label;
    spaced(ctx, s.text, cx, base, sp);
    return { size: size, width: wdt, height: asc + desc };
  }

  /* Dégradé métal (or, champagne…) à partir de trois teintes */
  function metal(ctx, x0, y0, x1, y1, a, b, c) {
    var g = ctx.createLinearGradient(x0, y0, x1, y1);
    g.addColorStop(0, a); g.addColorStop(0.18, c); g.addColorStop(0.36, b);
    g.addColorStop(0.52, c); g.addColorStop(0.7, a); g.addColorStop(0.86, b); g.addColorStop(1, c);
    return g;
  }

  /* Filet gravé : un trait sombre doublé d'un trait clair */
  function engrave(ctx, x, y, w, h, r, dark, alpha) {
    ctx.save();
    ctx.lineWidth = 1;
    ctx.strokeStyle = rgba(dark, 0.55 * alpha);
    roundRect(ctx, x + 0.5, y + 0.5, w, h, r);
    ctx.stroke();
    ctx.strokeStyle = 'rgba(255,248,225,' + (0.6 * alpha) + ')';
    roundRect(ctx, x + 1.5, y + 1.5, w, h, r);
    ctx.stroke();
    ctx.restore();
  }

  /* Petits traits de part et d'autre d'un libellé */
  function flank(ctx, cx, cy, halfW, gap, len, color) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = 0.8;
    ctx.beginPath();
    ctx.moveTo(cx - halfW - gap - len, cy); ctx.lineTo(cx - halfW - gap, cy);
    ctx.moveTo(cx + halfW + gap, cy); ctx.lineTo(cx + halfW + gap + len, cy);
    ctx.stroke();
    ctx.restore();
  }

  /* Texte répété le long d'un cercle, gravé (passe claire puis passe sombre) */
  function ringText(ctx, s, cx, cy, rText, size, fill, light) {
    var sp = s.spacing * size, fs = s.fontStyle || '', i;
    ctx.font = fs + s.weight + ' ' + size + 'px ' + s.family;
    var unit = s.text + ' • ';
    var unitW = textWidth(ctx, unit, sp) + sp;
    var circ = TAU * rText;
    while (unitW > circ && size > 6) {
      size *= 0.9; sp = s.spacing * size;
      ctx.font = fs + s.weight + ' ' + size + 'px ' + s.family;
      unitW = textWidth(ctx, unit, sp) + sp;
    }
    var reps = Math.max(1, Math.floor(circ / unitW)), full = '';
    for (i = 0; i < reps; i++) full += unit;
    var extra = (circ - reps * unitW) / full.length;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    for (var pass = 0; pass < 2; pass++) {
      var a = -Math.PI / 2;
      ctx.fillStyle = pass ? fill : light;
      for (i = 0; i < full.length; i++) {
        var ch = full.charAt(i), cw = ctx.measureText(ch).width + sp + extra;
        a += cw / 2 / rText;
        ctx.save();
        ctx.translate(cx + Math.cos(a) * rText, cy + Math.sin(a) * rText + (pass ? 0 : 1));
        ctx.rotate(a + Math.PI / 2);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
        a += cw / 2 / rText;
      }
    }
  }

  /* Paillette de feuille d'or : polygone irrégulier, dégradé métal et plis */
  function goldFlake(ctx, r, x, y, size, s) {
    var n = 5 + ((r() * 4) | 0), rot = r() * TAU, squash = 0.6 + r() * 0.5, i;
    ctx.save();
    ctx.beginPath();
    for (i = 0; i < n; i++) {
      var a = rot + i / n * TAU + (r() - 0.5) * 0.5, rad = size * (0.45 + r() * 0.65);
      ctx[i ? 'lineTo' : 'moveTo'](x + Math.cos(a) * rad, y + Math.sin(a) * rad * squash);
    }
    ctx.closePath();
    var g = ctx.createLinearGradient(x - size, y - size, x + size, y + size), bright = r() > 0.5;
    g.addColorStop(0, bright ? s.goldC : s.goldB);
    g.addColorStop(0.5, bright ? s.goldB : s.goldC);
    g.addColorStop(1, s.goldA);
    ctx.fillStyle = g;
    ctx.shadowColor = 'rgba(90,65,20,.28)';
    ctx.shadowBlur = 1.5;
    ctx.shadowOffsetY = 0.6;
    ctx.fill();
    ctx.shadowColor = 'rgba(0,0,0,0)';
    ctx.clip();
    ctx.lineWidth = 0.6;
    for (i = 0; i < 3; i++) {
      var b = r() * TAU;
      ctx.strokeStyle = i % 2 ? 'rgba(255,248,220,.6)' : 'rgba(110,78,20,.35)';
      ctx.beginPath();
      ctx.moveTo(x - Math.cos(b) * size, y - Math.sin(b) * size);
      ctx.lineTo(x + (r() - 0.5) * size * 0.4, y + (r() - 0.5) * size * 0.4);
      ctx.lineTo(x + Math.cos(b + 0.4) * size, y + Math.sin(b + 0.4) * size);
      ctx.stroke();
    }
    ctx.restore();
  }

  /* Branche d'eucalyptus au trait (feuilles rondes alternées) */
  function bezPt(p, t) {
    var u = 1 - t;
    return [u * u * u * p[0][0] + 3 * u * u * t * p[1][0] + 3 * u * t * t * p[2][0] + t * t * t * p[3][0],
            u * u * u * p[0][1] + 3 * u * u * t * p[1][1] + 3 * u * t * t * p[2][1] + t * t * t * p[3][1]];
  }
  function bezTan(p, t) {
    var u = 1 - t;
    return [3 * u * u * (p[1][0] - p[0][0]) + 6 * u * t * (p[2][0] - p[1][0]) + 3 * t * t * (p[3][0] - p[2][0]),
            3 * u * u * (p[1][1] - p[0][1]) + 6 * u * t * (p[2][1] - p[1][1]) + 3 * t * t * (p[3][1] - p[2][1])];
  }
  function branch(ctx, p, leaves, size, stroke, fill) {
    ctx.save();
    ctx.strokeStyle = stroke;
    ctx.lineCap = 'round';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(p[0][0], p[0][1]);
    ctx.bezierCurveTo(p[1][0], p[1][1], p[2][0], p[2][1], p[3][0], p[3][1]);
    ctx.stroke();
    for (var i = 0; i < leaves; i++) {
      var t = 0.1 + (i / Math.max(1, leaves - 1)) * 0.85;
      var pt = bezPt(p, t), tg = bezTan(p, t), ang = Math.atan2(tg[1], tg[0]);
      var side = i % 2 ? 1 : -1, sz = size * (1 - t * 0.45);
      var nx = Math.cos(ang + side * Math.PI / 2), ny = Math.sin(ang + side * Math.PI / 2);
      var lx = pt[0] + nx * sz * 1.05, ly = pt[1] + ny * sz * 1.05;
      ctx.lineWidth = 0.8;
      ctx.beginPath(); ctx.moveTo(pt[0], pt[1]); ctx.lineTo(lx - nx * sz * 0.8, ly - ny * sz * 0.8); ctx.stroke();
      ctx.beginPath();
      ctx.ellipse(lx, ly, sz, sz * 0.82, ang, 0, TAU);
      ctx.fillStyle = fill;
      ctx.fill();
      ctx.lineWidth = 0.9;
      ctx.stroke();
      ctx.lineWidth = 0.5;
      ctx.beginPath(); ctx.moveTo(lx - nx * sz * 0.8, ly - ny * sz * 0.8); ctx.lineTo(lx + nx * sz * 0.7, ly + ny * sz * 0.7); ctx.stroke();
    }
    ctx.restore();
  }

  /* Bande de pli satiné, adoucie par empilement de traits très légers */
  function fold(ctx, w, y0, amp, freq, phase, thick, color, alpha) {
    ctx.save();
    ctx.lineWidth = thick / 6;
    for (var k = -6; k <= 6; k++) {
      var t = 1 - Math.abs(k) / 7;
      ctx.strokeStyle = rgba(color, alpha * t * t);
      ctx.beginPath();
      for (var x = -10; x <= w + 10; x += 6) {
        var y = y0 + k * thick / 12 + Math.sin(x / w * Math.PI * freq + phase) * amp;
        if (x === -10) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
    ctx.restore();
  }

  /* ---------------------------------------------------------------------
     Les designs (un peintre par thème). Les couleurs viennent des variables
     CSS --ks-cover-a/b/c et --ks-label : modifiez-les dans le CSS.
     --------------------------------------------------------------------- */

  var THEMES = {
    gold: function (ctx, w, h, s, inst) {
      var r = rng(11), i;
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, s.a); g.addColorStop(0.22, s.b); g.addColorStop(0.42, s.c);
      g.addColorStop(0.58, s.b); g.addColorStop(0.8, s.a); g.addColorStop(1, s.b);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // Feuille froissée : facettes claires et sombres
      ctx.globalCompositeOperation = 'soft-light';
      for (i = 0; i < 60; i++) {
        var x = r() * w, y = r() * h, rad = (0.06 + r() * 0.22) * Math.max(w, h);
        var rg = ctx.createRadialGradient(x, y, 0, x, y, rad);
        rg.addColorStop(0, r() > 0.45 ? 'rgba(255,255,255,.5)' : 'rgba(80,50,0,.26)');
        rg.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = rg;
        ctx.fillRect(x - rad, y - rad, rad * 2, rad * 2);
      }
      // Brossage horizontal
      ctx.globalCompositeOperation = 'overlay';
      for (var yy = 0; yy < h; yy += 1.5) {
        ctx.fillStyle = r() > 0.5 ? 'rgba(255,255,255,' + (r() * 0.09) + ')' : 'rgba(0,0,0,' + (r() * 0.045) + ')';
        ctx.fillRect(0, yy, w, 1);
      }
      ctx.globalCompositeOperation = 'source-over';
      grain(ctx, inst, 0.16);

      // Paillettes
      for (i = 0; i < 110; i++) {
        var fs = r() * 1.3 + 0.3;
        ctx.fillStyle = 'rgba(255,250,225,' + (0.25 + r() * 0.5) + ')';
        ctx.fillRect(r() * w, r() * h, fs, fs);
      }

      // Traits de grattage stylisés derrière le texte
      var mh = h * 0.42, mw = w * 0.066;
      ctx.fillStyle = rgba(s.a, 0.42);
      for (i = 0; i < 5; i++) {
        ctx.save();
        ctx.translate(w / 2 + (i - 2) * w * 0.085, h / 2 + (r() - 0.5) * h * 0.05);
        ctx.rotate(0.3 + (r() - 0.5) * 0.08);
        ctx.beginPath();
        ctx.moveTo(-mw / 2 + r() * 3, -mh / 2);
        ctx.lineTo(mw / 2, -mh / 2 + r() * 6);
        ctx.lineTo(mw / 2 - r() * 3, mh / 2);
        ctx.lineTo(-mw / 2, mh / 2 - r() * 6);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }

      label(ctx, s, w / 2, h / 2, { maxW: w * 0.82, maxSize: h * 0.18, shadow: 'rgba(80,52,8,.5)', highlight: 'rgba(255,255,255,.35)' });
      innerEdge(ctx, w, h, s.radius, 'rgba(255,245,200,.45)');
    },

    holo: function (ctx, w, h, s, inst) {
      var r = rng(23), i;
      var g = ctx.createLinearGradient(0, h, w, 0);
      g.addColorStop(0, s.a); g.addColorStop(0.25, s.b); g.addColorStop(0.5, s.c);
      g.addColorStop(0.72, '#d3f6cf'); g.addColorStop(0.88, '#faeab0'); g.addColorStop(1, s.a);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // Bandes d'interférence
      ctx.globalCompositeOperation = 'overlay';
      var b = ctx.createLinearGradient(0, 0, w, h * 0.7);
      for (i = 0; i <= 8; i++) b.addColorStop(i / 8, i % 2 ? 'rgba(255,255,255,.65)' : 'rgba(150,110,230,.35)');
      ctx.fillStyle = b;
      ctx.fillRect(0, 0, w, h);

      ctx.globalCompositeOperation = 'screen';
      var glow = ctx.createRadialGradient(w * 0.25, h * 0.2, 0, w * 0.25, h * 0.2, w * 0.7);
      glow.addColorStop(0, 'rgba(255,255,255,.7)');
      glow.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = glow;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';

      // Réseau holographique fin
      ctx.strokeStyle = 'rgba(255,255,255,.22)';
      ctx.lineWidth = 0.6;
      ctx.beginPath();
      for (var x = -h; x < w + h; x += 3.2) { ctx.moveTo(x, h); ctx.lineTo(x + h * 0.6, 0); }
      ctx.stroke();
      grain(ctx, inst, 0.07);

      for (i = 0; i < 16; i++) star4(ctx, r() * w, r() * h, 2 + r() * 5, 'rgba(255,255,255,' + (0.55 + r() * 0.45) + ')');

      label(ctx, s, w / 2, h / 2, { maxW: w * 0.8, maxSize: h * 0.17, fill: s.label, shadow: 'rgba(90,55,170,.5)', shadowY: 1.5, glow: 'rgba(100,60,180,.6)', glowBlur: 10 * inst.dpr });
      innerEdge(ctx, w, h, s.radius, 'rgba(255,255,255,.7)');
    },

    silver: function (ctx, w, h, s, inst) {
      var g = ctx.createLinearGradient(0, 0, w * 0.35, h);
      g.addColorStop(0, s.a); g.addColorStop(0.3, s.c); g.addColorStop(0.5, s.b);
      g.addColorStop(0.7, s.c); g.addColorStop(1, s.a);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      ctx.globalCompositeOperation = 'overlay';
      var band = ctx.createLinearGradient(0, 0, w, h);
      band.addColorStop(0.3, 'rgba(255,255,255,0)');
      band.addColorStop(0.42, 'rgba(255,255,255,.55)');
      band.addColorStop(0.54, 'rgba(255,255,255,0)');
      ctx.fillStyle = band;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      grain(ctx, inst, 0.3);

      // Motif de sécurité : le libellé répété en petit
      ctx.save();
      ctx.translate(w / 2, h / 2);
      ctx.rotate(-0.2);
      ctx.fillStyle = rgba(s.label, 0.11);
      ctx.font = s.weight + ' ' + Math.max(8, h * 0.07) + 'px ' + s.family;
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'left';
      var unit = s.text + '  •  ', uw = ctx.measureText(unit).width, lh = h * 0.12, row = 0;
      for (var y = -h; y < h; y += lh, row++) {
        for (var x = -w - uw + (row % 2) * uw / 2; x < w; x += uw) ctx.fillText(unit, x, y);
      }
      ctx.restore();

      // Pastille centrale
      var pw = w * 0.7, ph = h * 0.34;
      ctx.fillStyle = 'rgba(255,255,255,.28)';
      roundRect(ctx, (w - pw) / 2, (h - ph) / 2, pw, ph, ph / 2);
      ctx.fill();
      ctx.strokeStyle = rgba(s.label, 0.25);
      ctx.lineWidth = 1;
      ctx.stroke();

      label(ctx, s, w / 2, h / 2, { maxW: pw * 0.82, maxSize: ph * 0.62, fill: s.label, shadow: 'rgba(255,255,255,.8)', shadowY: 1.2 });
      innerEdge(ctx, w, h, s.radius, 'rgba(255,255,255,.5)');
    },

    coin: function (ctx, w, h, s, inst) {
      var cx = w / 2, cy = h / 2, R = Math.min(w, h) / 2, i;
      var g = ctx.createRadialGradient(cx - R * 0.3, cy - R * 0.35, R * 0.05, cx, cy, R);
      g.addColorStop(0, s.c); g.addColorStop(0.5, s.b); g.addColorStop(1, s.a);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // Tranche crénelée
      ctx.save();
      ctx.translate(cx, cy);
      var n = Math.round(R * 1.4);
      for (i = 0; i < n; i++) {
        ctx.rotate(TAU / n);
        ctx.fillStyle = i % 2 ? 'rgba(255,240,190,.4)' : 'rgba(70,45,5,.4)';
        ctx.fillRect(R * 0.9, -R * 0.013, R * 0.12, R * 0.026);
      }
      ctx.restore();

      function ring(rad, dark) {
        ctx.beginPath(); ctx.arc(cx, cy, rad, 0, TAU);
        ctx.strokeStyle = 'rgba(70,45,5,' + dark + ')'; ctx.lineWidth = 2; ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, rad + 1.6, 0, TAU);
        ctx.strokeStyle = 'rgba(255,246,214,.55)'; ctx.lineWidth = 1; ctx.stroke();
      }
      ring(R * 0.88, 0.55);
      ring(R * 0.62, 0.4);

      // Texte gravé en cercle
      ringText(ctx, s, cx, cy, R * 0.75, R * 0.13, s.label, 'rgba(255,246,214,.6)');

      // Étoile centrale en relief
      star5(ctx, cx, cy + 1.5, R * 0.36, R * 0.15);
      ctx.fillStyle = 'rgba(70,45,5,.45)';
      ctx.fill();
      var sg = ctx.createLinearGradient(cx - R * 0.3, cy - R * 0.3, cx + R * 0.3, cy + R * 0.3);
      sg.addColorStop(0, s.c); sg.addColorStop(1, s.b);
      star5(ctx, cx, cy, R * 0.36, R * 0.15);
      ctx.fillStyle = sg;
      ctx.fill();

      ctx.globalCompositeOperation = 'soft-light';
      var sh = ctx.createLinearGradient(0, 0, w, h);
      sh.addColorStop(0.2, 'rgba(255,255,255,0)');
      sh.addColorStop(0.4, 'rgba(255,255,255,.7)');
      sh.addColorStop(0.6, 'rgba(255,255,255,0)');
      ctx.fillStyle = sh;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      grain(ctx, inst, 0.12);
    },

    noir: function (ctx, w, h, s, inst) {
      var g = ctx.createRadialGradient(w / 2, h * 0.4, 0, w / 2, h / 2, Math.max(w, h) * 0.75);
      g.addColorStop(0, s.b); g.addColorStop(1, s.a);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      // Guillochis (comme sur un billet)
      ctx.strokeStyle = rgba(s.c, 0.15);
      ctx.lineWidth = 0.7;
      var N = 28;
      for (var k = 0; k < N; k++) {
        ctx.beginPath();
        for (var x = 0; x <= w; x += 3) {
          var y = h * (k / (N - 1)) + Math.sin(x / w * Math.PI * 4 + k * 0.35) * h * 0.05 + Math.sin(x / w * Math.PI * 9 - k * 0.2) * h * 0.018;
          if (x) ctx.lineTo(x, y); else ctx.moveTo(x, y);
        }
        ctx.stroke();
      }

      // Double filet doré
      var m = Math.min(w, h) * 0.055;
      ctx.strokeStyle = rgba(s.c, 0.9);
      ctx.lineWidth = 1;
      ctx.strokeRect(m + 0.5, m + 0.5, w - 2 * m - 1, h - 2 * m - 1);
      ctx.strokeStyle = rgba(s.c, 0.4);
      ctx.lineWidth = 0.6;
      ctx.strokeRect(m + 4.5, m + 4.5, w - 2 * m - 9, h - 2 * m - 9);
      ctx.fillStyle = s.c;
      [[m, m], [w - m, m], [m, h - m], [w - m, h - m]].forEach(function (p) {
        ctx.beginPath();
        ctx.moveTo(p[0], p[1] - 4); ctx.lineTo(p[0] + 4, p[1]); ctx.lineTo(p[0], p[1] + 4); ctx.lineTo(p[0] - 4, p[1]);
        ctx.fill();
      });

      var gg = ctx.createLinearGradient(0, h * 0.42, 0, h * 0.58);
      gg.addColorStop(0, '#f6e2ae'); gg.addColorStop(0.5, s.c); gg.addColorStop(1, '#8f6d32');
      var L = label(ctx, s, w / 2, h / 2, { maxW: w * 0.6, maxSize: h * 0.1, fill: gg, shadow: 'rgba(0,0,0,.7)' });

      // Filets de part et d'autre du libellé
      ctx.strokeStyle = rgba(s.c, 0.7);
      ctx.lineWidth = 0.8;
      var gap = L.size * 0.8, x0 = m + 16, x1 = w / 2 - L.width / 2 - gap, x2 = w / 2 + L.width / 2 + gap, x3 = w - m - 16;
      if (x1 > x0) {
        ctx.beginPath(); ctx.moveTo(x0, h / 2); ctx.lineTo(x1, h / 2); ctx.moveTo(x2, h / 2); ctx.lineTo(x3, h / 2); ctx.stroke();
      }
      star4(ctx, w / 2, h / 2 - L.size * 1.25, L.size * 0.28, rgba(s.c, 0.9));
      star4(ctx, w / 2, h / 2 + L.size * 1.25, L.size * 0.28, rgba(s.c, 0.9));
      grain(ctx, inst, 0.08);
    },

    pop: function (ctx, w, h, s, inst) {
      var r = rng(71), i;
      ctx.fillStyle = s.b;
      ctx.fillRect(0, 0, w, h);

      // Trame de points (demi-teinte)
      ctx.fillStyle = s.a;
      var step = Math.max(8, w / 30), row = 0;
      for (var y = 0; y < h + step; y += step * 0.87, row++) {
        for (var x = (row % 2) * step / 2; x < w + step; x += step) {
          var t = (x / w + y / h) / 2, rad = step * 0.5 * Math.pow(t, 1.3);
          if (rad > 0.5) { ctx.beginPath(); ctx.arc(x, y, rad, 0, TAU); ctx.fill(); }
        }
      }

      // Confettis
      var cols = [s.c, '#3dd6f5', '#ffffff', s.label];
      var u = Math.max(3, w / 90);
      for (i = 0; i < 38; i++) {
        ctx.save();
        ctx.translate(r() * w, r() * h);
        ctx.rotate(r() * Math.PI);
        ctx.fillStyle = ctx.strokeStyle = cols[i % 4];
        if (i % 3 === 0) ctx.fillRect(-u * 1.6, -u * 0.6, u * 3.2, u * 1.2);
        else if (i % 3 === 1) { ctx.beginPath(); ctx.arc(0, 0, u * 0.9, 0, TAU); ctx.fill(); }
        else {
          ctx.lineWidth = u * 0.7; ctx.lineCap = 'round';
          ctx.beginPath(); ctx.moveTo(-u * 2, 0);
          ctx.quadraticCurveTo(-u, -u * 1.5, 0, 0); ctx.quadraticCurveTo(u, u * 1.5, u * 2, 0);
          ctx.stroke();
        }
        ctx.restore();
      }

      // Bande adhésive centrale
      ctx.save();
      ctx.translate(w / 2, h / 2);
      ctx.rotate(-0.06);
      var tw = w * 0.84, th = h * 0.3, notch = th * 0.18;
      function tape(dx, dy) {
        ctx.beginPath();
        ctx.moveTo(-tw / 2 + dx, -th / 2 + dy);
        ctx.lineTo(tw / 2 + dx, -th / 2 + dy);
        for (var z = 1; z <= 4; z++) ctx.lineTo(tw / 2 + dx - (z % 2 ? notch : 0), -th / 2 + dy + th * z / 4);
        ctx.lineTo(-tw / 2 + dx, th / 2 + dy);
        for (z = 3; z >= 0; z--) ctx.lineTo(-tw / 2 + dx + (z % 2 ? notch : 0), -th / 2 + dy + th * z / 4);
        ctx.closePath();
      }
      tape(4, 5); ctx.fillStyle = rgba(s.label, 0.9); ctx.fill();
      tape(0, 0); ctx.fillStyle = s.c; ctx.fill();
      label(ctx, s, 0, 0, { maxW: tw * 0.78, maxSize: th * 0.6, fill: s.label });
      ctx.restore();
      grain(ctx, inst, 0.06);
    },

    /* Champagne brossé, double filet gravé, monogramme en relief */
    gilt: function (ctx, w, h, s, inst) {
      var r = rng(19), i;
      ctx.fillStyle = metal(ctx, 0, 0, w, h * 0.7, s.a, s.b, s.c);
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'soft-light';
      for (i = 0; i < 26; i++) {
        var x = r() * w, y = r() * h, rad = (0.15 + r() * 0.35) * Math.max(w, h);
        var rg = ctx.createRadialGradient(x, y, 0, x, y, rad);
        rg.addColorStop(0, r() > 0.4 ? 'rgba(255,255,255,.35)' : 'rgba(70,50,10,.18)');
        rg.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = rg;
        ctx.fillRect(x - rad, y - rad, rad * 2, rad * 2);
      }
      ctx.globalCompositeOperation = 'overlay';
      for (var yy = 0; yy < h; yy += 1) {
        ctx.fillStyle = r() > 0.5 ? 'rgba(255,255,255,' + (r() * 0.07) + ')' : 'rgba(0,0,0,' + (r() * 0.035) + ')';
        ctx.fillRect(0, yy, w, 0.6);
      }
      ctx.globalCompositeOperation = 'source-over';
      grain(ctx, inst, 0.1);

      var m = Math.min(w, h) * 0.065, rr = Math.max(2, s.radius * 0.55);
      engrave(ctx, m, m, w - 2 * m, h - 2 * m, rr, s.a, 1);
      engrave(ctx, m + 5, m + 5, w - 2 * m - 10, h - 2 * m - 10, Math.max(1, rr - 4), s.a, 0.55);

      var mk = s.mark;
      if (mk) {
        label(ctx, mk, w / 2, h * 0.43, { maxW: w * 0.4, maxSize: h * 0.38, fill: metal(ctx, 0, h * 0.22, 0, h * 0.62, mk.label, s.a, s.c), shadow: rgba(s.a, 0.55), shadowY: 1.4, highlight: 'rgba(255,250,232,.85)' });
        var L = label(ctx, s, w / 2, h * 0.75, { maxW: w * 0.6, maxSize: h * 0.068, fill: s.label, shadow: 'rgba(255,248,225,.75)', shadowY: 1 });
        flank(ctx, w / 2, h * 0.75, L.width / 2, 10, Math.min(28, w * 0.08), rgba(s.a, 0.6));
      } else {
        label(ctx, s, w / 2, h / 2, { maxW: w * 0.7, maxSize: h * 0.12, fill: s.label, shadow: 'rgba(255,248,225,.75)', shadowY: 1 });
      }
      innerEdge(ctx, w, h, s.radius, 'rgba(255,248,225,.55)');
    },

    /* Baume translucide constellé de paillettes de feuille d'or */
    flakes: function (ctx, w, h, s, inst) {
      var r = rng(29), i, x, y, dx, dy;
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, s.b); g.addColorStop(0.5, s.c); g.addColorStop(1, s.b);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      var v = ctx.createRadialGradient(w / 2, h / 2, Math.min(w, h) * 0.2, w / 2, h / 2, Math.max(w, h) * 0.75);
      v.addColorStop(0, 'rgba(255,255,255,0)');
      v.addColorStop(1, rgba(s.a, 0.32));
      ctx.fillStyle = v;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'screen';
      var band = ctx.createLinearGradient(0, 0, w, h);
      band.addColorStop(0.28, 'rgba(255,255,255,0)');
      band.addColorStop(0.4, 'rgba(255,255,255,.55)');
      band.addColorStop(0.52, 'rgba(255,255,255,0)');
      ctx.fillStyle = band;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      grain(ctx, inst, 0.05);

      var cx = w / 2, cy = h / 2, ex = w * 0.36, ey = h * 0.22, k = w / 330;
      var clusters = [[0.1, 0.18], [0.88, 0.16], [0.08, 0.84], [0.9, 0.82], [0.5, 0.05], [0.52, 0.96], [0.22, 0.5], [0.8, 0.5]];
      var count = Math.round(w * h / 700);
      for (i = 0; i < count; i++) {
        var c = clusters[i % clusters.length];
        x = (c[0] + (r() + r() + r() - 1.5) * 0.16) * w;
        y = (c[1] + (r() + r() + r() - 1.5) * 0.2) * h;
        dx = (x - cx) / ex; dy = (y - cy) / ey;
        if (dx * dx + dy * dy < 1) continue;
        goldFlake(ctx, r, x, y, (r() < 0.16 ? 7 + r() * 9 : 2 + r() * 5) * k, s);
      }
      for (i = 0; i < 170; i++) {
        x = r() * w; y = r() * h;
        dx = (x - cx) / (ex * 0.85); dy = (y - cy) / (ey * 0.85);
        if (dx * dx + dy * dy < 1) continue;
        ctx.fillStyle = rgba(s.goldB, 0.3 + r() * 0.5);
        ctx.fillRect(x, y, 0.6 + r() * 1.2, 0.6 + r() * 1.2);
      }

      var mk = s.mark, ly = mk ? cy + h * 0.03 : cy;
      if (mk) label(ctx, mk, cx, cy - h * 0.1, { maxW: w * 0.5, maxSize: h * 0.05, fill: mk.label });
      var L = label(ctx, s, cx, ly, { maxW: w * 0.56, maxSize: h * 0.15, fill: s.label });
      ctx.strokeStyle = rgba(s.goldB, 0.85);
      ctx.lineWidth = 0.8;
      ctx.beginPath();
      ctx.moveTo(cx - L.width * 0.22, ly + L.size * 0.62);
      ctx.lineTo(cx + L.width * 0.22, ly + L.size * 0.62);
      ctx.stroke();
      innerEdge(ctx, w, h, s.radius, rgba(s.goldB, 0.75));
    },

    /* Satin de sauge à plis doux, filet d'or */
    silk: function (ctx, w, h, s, inst) {
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, s.a); g.addColorStop(0.35, s.b); g.addColorStop(0.55, s.c);
      g.addColorStop(0.75, s.b); g.addColorStop(1, s.a);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      var soft = 'filter' in ctx;
      if (soft) ctx.filter = 'blur(' + Math.round(h * 0.025) + 'px)';
      fold(ctx, w, h * 0.16, h * 0.12, 1.2, 0.3, h * 0.5, '#ffffff', 0.09);
      fold(ctx, w, h * 0.5, h * 0.16, 1.0, 2.1, h * 0.45, '#16230f', 0.08);
      fold(ctx, w, h * 0.8, h * 0.1, 1.4, 4.0, h * 0.5, '#ffffff', 0.08);
      fold(ctx, w, h * 0.34, h * 0.08, 1.6, 5.2, h * 0.3, '#16230f', 0.06);
      if (soft) ctx.filter = 'none';
      ctx.globalCompositeOperation = 'soft-light';
      var sh = ctx.createLinearGradient(0, 0, w, h);
      sh.addColorStop(0.25, 'rgba(255,255,255,0)');
      sh.addColorStop(0.45, 'rgba(255,255,255,.55)');
      sh.addColorStop(0.62, 'rgba(255,255,255,0)');
      ctx.fillStyle = sh;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      grain(ctx, inst, 0.04);

      var m = Math.min(w, h) * 0.07;
      ctx.strokeStyle = metal(ctx, 0, 0, w, h, s.goldA, s.goldB, s.goldC);
      ctx.lineWidth = 1.2;
      roundRect(ctx, m, m, w - 2 * m, h - 2 * m, Math.max(2, s.radius * 0.5));
      ctx.stroke();
      ctx.fillStyle = s.goldC;
      [[w / 2, m], [w / 2, h - m]].forEach(function (p) {
        ctx.beginPath();
        ctx.moveTo(p[0], p[1] - 4); ctx.lineTo(p[0] + 4, p[1]); ctx.lineTo(p[0], p[1] + 4); ctx.lineTo(p[0] - 4, p[1]);
        ctx.fill();
      });

      var gold = metal(ctx, 0, h * 0.3, 0, h * 0.75, s.goldC, s.goldB, s.goldC), mk = s.mark;
      if (mk) {
        label(ctx, mk, w / 2, h * 0.43, { maxW: w * 0.55, maxSize: h * 0.2, fill: gold, shadow: 'rgba(22,35,15,.35)', shadowY: 1.2 });
        var L = label(ctx, s, w / 2, h * 0.66, { maxW: w * 0.6, maxSize: h * 0.06, fill: s.label, shadow: 'rgba(22,35,15,.3)', shadowY: 1 });
        flank(ctx, w / 2, h * 0.66, L.width / 2, 10, Math.min(26, w * 0.07), rgba(s.goldC, 0.7));
      } else {
        label(ctx, s, w / 2, h / 2, { maxW: w * 0.66, maxSize: h * 0.1, fill: gold, shadow: 'rgba(22,35,15,.35)', shadowY: 1 });
      }
    },

    /* Médaille ronde : perles, rosace guillochée, monogramme */
    medal: function (ctx, w, h, s, inst) {
      var cx = w / 2, cy = h / 2, R = Math.min(w, h) / 2, i;
      var g = ctx.createRadialGradient(cx - R * 0.35, cy - R * 0.4, R * 0.05, cx, cy, R * 1.05);
      g.addColorStop(0, s.c); g.addColorStop(0.45, s.b); g.addColorStop(1, s.a);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      var n = Math.round(R * 0.5), br = R * 0.028;
      for (i = 0; i < n; i++) {
        var a = i / n * TAU, bx = cx + Math.cos(a) * R * 0.925, by = cy + Math.sin(a) * R * 0.925;
        var bg = ctx.createRadialGradient(bx - br * 0.4, by - br * 0.4, 0, bx, by, br);
        bg.addColorStop(0, 'rgba(255,250,225,.95)');
        bg.addColorStop(0.5, s.b);
        bg.addColorStop(1, rgba(s.a, 0.95));
        ctx.fillStyle = bg;
        ctx.beginPath(); ctx.arc(bx, by, br, 0, TAU); ctx.fill();
      }
      function ring(rad, alpha) {
        ctx.beginPath(); ctx.arc(cx, cy, rad, 0, TAU);
        ctx.strokeStyle = rgba(s.a, alpha); ctx.lineWidth = 1.6; ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, rad + 1.4, 0, TAU);
        ctx.strokeStyle = 'rgba(255,248,225,.6)'; ctx.lineWidth = 0.9; ctx.stroke();
      }
      ring(R * 0.87, 0.6);
      ring(R * 0.64, 0.5);

      ctx.save();
      ctx.beginPath(); ctx.arc(cx, cy, R * 0.63, 0, TAU); ctx.clip();
      ctx.strokeStyle = rgba(s.a, 0.3);
      ctx.lineWidth = 0.6;
      for (i = 0; i < 48; i++) {
        var a2 = i / 48 * TAU;
        ctx.beginPath(); ctx.arc(cx + Math.cos(a2) * R * 0.16, cy + Math.sin(a2) * R * 0.16, R * 0.42, 0, TAU); ctx.stroke();
      }
      ctx.restore();

      var cd = ctx.createRadialGradient(cx - R * 0.12, cy - R * 0.14, 0, cx, cy, R * 0.34);
      cd.addColorStop(0, s.c); cd.addColorStop(1, s.b);
      ctx.fillStyle = cd;
      ctx.beginPath(); ctx.arc(cx, cy, R * 0.33, 0, TAU); ctx.fill();
      ring(R * 0.33, 0.5);

      if (s.mark) label(ctx, s.mark, cx, cy, { maxW: R * 0.5, maxSize: R * 0.46, fill: metal(ctx, 0, cy - R * 0.25, 0, cy + R * 0.25, s.mark.label, s.a, s.c), shadow: rgba(s.a, 0.6), shadowY: 1.5, highlight: 'rgba(255,250,232,.85)' });
      ringText(ctx, s, cx, cy, R * 0.755, R * 0.1, s.label, 'rgba(255,248,225,.65)');

      ctx.globalCompositeOperation = 'soft-light';
      var sh = ctx.createLinearGradient(0, 0, w, h);
      sh.addColorStop(0.2, 'rgba(255,255,255,0)');
      sh.addColorStop(0.42, 'rgba(255,255,255,.6)');
      sh.addColorStop(0.6, 'rgba(255,255,255,0)');
      ctx.fillStyle = sh;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      grain(ctx, inst, 0.1);
    },

    /* Nacre irisée : nuées pastel, strates, éclats */
    pearl: function (ctx, w, h, s, inst) {
      var r = rng(37), i;
      ctx.fillStyle = s.b;
      ctx.fillRect(0, 0, w, h);
      var tints = ['#f5d3db', '#d3ebdf', '#e0d9f4', '#f8e3cc', '#d6eef2'];
      for (i = 0; i < 34; i++) {
        var x = r() * w, y = r() * h, rad = (0.12 + r() * 0.3) * Math.max(w, h);
        var rg = ctx.createRadialGradient(x, y, 0, x, y, rad);
        rg.addColorStop(0, rgba(tints[i % 5], 0.75));
        rg.addColorStop(1, rgba(tints[i % 5], 0));
        ctx.globalAlpha = 0.55;
        ctx.fillStyle = rg;
        ctx.fillRect(x - rad, y - rad, rad * 2, rad * 2);
      }
      ctx.globalAlpha = 1;
      ctx.lineWidth = 0.7;
      for (var k = 0; k < 34; k++) {
        var y0 = h * (k / 33);
        ctx.strokeStyle = k % 2 ? 'rgba(255,255,255,.45)' : 'rgba(160,150,185,.12)';
        ctx.beginPath();
        for (var xx = 0; xx <= w; xx += 4) {
          var yy = y0 + Math.sin(xx / w * Math.PI * 2.2 + k * 0.45) * h * 0.06 + Math.sin(xx / w * Math.PI * 5.3 + k * 0.8) * h * 0.015;
          if (xx) ctx.lineTo(xx, yy); else ctx.moveTo(xx, yy);
        }
        ctx.stroke();
      }
      ctx.globalCompositeOperation = 'screen';
      [[0.28, 0.22, 0.7], [0.76, 0.8, 0.45]].forEach(function (q) {
        var gl = ctx.createRadialGradient(w * q[0], h * q[1], 0, w * q[0], h * q[1], w * 0.45);
        gl.addColorStop(0, 'rgba(255,255,255,' + q[2] + ')');
        gl.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = gl;
        ctx.fillRect(0, 0, w, h);
      });
      ctx.globalCompositeOperation = 'source-over';
      for (i = 0; i < 22; i++) star4(ctx, r() * w, r() * h, 1.5 + r() * 3.5, 'rgba(255,255,255,' + (0.6 + r() * 0.4) + ')');
      grain(ctx, inst, 0.04);

      var cx = w / 2, cy = h / 2, mk = s.mark, ly = mk ? cy + h * 0.03 : cy;
      if (mk) label(ctx, mk, cx, cy - h * 0.1, { maxW: w * 0.5, maxSize: h * 0.05, fill: mk.label });
      var L = label(ctx, s, cx, ly, { maxW: w * 0.56, maxSize: h * 0.15, fill: s.label, highlight: 'rgba(255,255,255,.9)' });
      ctx.strokeStyle = rgba(mk ? mk.label : s.label, 0.6);
      ctx.lineWidth = 0.8;
      ctx.beginPath();
      ctx.moveTo(cx - L.width * 0.22, ly + L.size * 0.62);
      ctx.lineTo(cx + L.width * 0.22, ly + L.size * 0.62);
      ctx.stroke();
      innerEdge(ctx, w, h, s.radius, 'rgba(255,255,255,.85)');
    },

    /* Carte vert profond, eucalyptus et filets dorés */
    botanic: function (ctx, w, h, s, inst) {
      var g = ctx.createRadialGradient(w * 0.5, h * 0.45, 0, w * 0.5, h * 0.5, Math.max(w, h) * 0.75);
      g.addColorStop(0, s.b); g.addColorStop(1, s.a);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      grain(ctx, inst, 0.12);

      var gold = metal(ctx, 0, 0, w, h, s.goldA, s.goldB, s.goldC), leafFill = rgba(s.goldB, 0.14), u = Math.min(w, h);
      branch(ctx, [[-w * 0.02, h * 0.36], [w * 0.1, h * 0.18], [w * 0.2, h * 0.07], [w * 0.36, -h * 0.02]], 7, u * 0.045, gold, leafFill);
      branch(ctx, [[w * 1.02, h * 0.64], [w * 0.9, h * 0.82], [w * 0.8, h * 0.93], [w * 0.64, h * 1.02]], 7, u * 0.045, gold, leafFill);
      branch(ctx, [[w * 0.05, h * 1.02], [w * 0.09, h * 0.9], [w * 0.15, h * 0.82], [w * 0.24, h * 0.78]], 4, u * 0.032, gold, leafFill);
      branch(ctx, [[w * 0.95, -h * 0.02], [w * 0.91, h * 0.1], [w * 0.85, h * 0.18], [w * 0.76, h * 0.22]], 4, u * 0.032, gold, leafFill);

      var m = u * 0.07;
      ctx.strokeStyle = gold;
      ctx.lineWidth = 1;
      roundRect(ctx, m, m, w - 2 * m, h - 2 * m, Math.max(2, s.radius * 0.5));
      ctx.stroke();
      ctx.globalAlpha = 0.5;
      ctx.lineWidth = 0.6;
      roundRect(ctx, m + 4, m + 4, w - 2 * m - 8, h - 2 * m - 8, Math.max(1, s.radius * 0.5 - 3));
      ctx.stroke();
      ctx.globalAlpha = 1;

      var text = metal(ctx, 0, h * 0.35, 0, h * 0.7, s.goldC, s.goldB, s.goldC), mk = s.mark;
      if (mk) label(ctx, mk, w / 2, h * 0.4, { maxW: w * 0.5, maxSize: h * 0.1, fill: text, shadow: 'rgba(0,0,0,.35)', shadowY: 1 });
      var ly = mk ? h * 0.58 : h / 2;
      var L = label(ctx, s, w / 2, ly, { maxW: w * 0.56, maxSize: h * 0.065, fill: s.label, shadow: 'rgba(0,0,0,.35)', shadowY: 1 });
      flank(ctx, w / 2, ly, L.width / 2, 10, Math.min(24, w * 0.07), rgba(s.goldB, 0.8));
    },

    image: function (ctx, w, h, s, inst) {
      var img = inst.coverImg;
      if (!img || !img.complete || !img.naturalWidth) { THEMES.gold(ctx, w, h, s, inst); return; }
      var ir = img.naturalWidth / img.naturalHeight, cr = w / h, dw, dh;
      if (ir > cr) { dh = h; dw = h * ir; } else { dw = w; dh = w / ir; }
      ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
      if (inst.labelEl && s.text) label(ctx, s, w / 2, h / 2, { maxW: w * 0.8, maxSize: h * 0.17, shadow: 'rgba(0,0,0,.3)' });
    }
  };

  /* ---------------------------------------------------------------------
     Une carte à gratter
     --------------------------------------------------------------------- */

  function Scratch(card) {
    var self = this;
    this.card = card;
    this.key = card.id || 'ks-card';
    this.labelEl = card.querySelector('.ks-cover-label');
    this.markEl = card.querySelector('.ks-cover-mark');
    this.prizeEl = card.querySelector('.ks-prize');
    this.coverImg = card.querySelector('.ks-cover-img');
    this.theme = 'gold';
    if (this.coverImg) this.theme = 'image';
    else for (var i = 0; i < THEME_NAMES.length; i++) if (card.classList.contains('ks-' + THEME_NAMES[i])) { this.theme = THEME_NAMES[i]; break; }
    this.fx = FX[this.theme] || {};
    this.circle = this.theme === 'coin' || this.theme === 'medal' || card.classList.contains('ks-shape-circle');
    this.strokes = [];
    this.particles = [];
    this.revealed = false;
    this.ratio = 0;
    this.w = this.h = 0;

    this.canvas = document.createElement('canvas');
    this.canvas.className = 'ks-canvas';
    this.canvas.setAttribute('aria-hidden', 'true');
    this.ctx = this.canvas.getContext('2d');
    card.appendChild(this.canvas);

    if (CONFIG.dust && !reduceMotion) {
      this.dust = document.createElement('canvas');
      this.dust.className = 'ks-dust';
      this.dust.setAttribute('aria-hidden', 'true');
      this.dctx = this.dust.getContext('2d');
      card.appendChild(this.dust);
    }

    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'ks-a11y';
    this.button.textContent = CONFIG.a11yLabel;
    this.button.addEventListener('click', function () {
      self.reveal();
      if (self.prizeEl) { self.prizeEl.setAttribute('tabindex', '-1'); self.prizeEl.focus(); }
    });
    card.appendChild(this.button);

    if (this.prizeEl) this.prizeEl.setAttribute('aria-hidden', 'true');
    if (CONFIG.coinCursor) this.canvas.style.cursor = coinCursor();

    this.claims = findClaims(card);
    this.lockClaim();
    this.bind();
    this.layout(true);
    card.classList.add('is-ready');
    // Le calque statique (celui de l'éditeur Klaviyo) est masqué en style en ligne :
    // aucun style du formulaire ne peut le faire réapparaître après le grattage.
    this.cover = card.querySelector('.ks-cover');
    if (this.cover) this.cover.style.setProperty('display', 'none', 'important');

    if (document.fonts && this.labelEl) {
      var st = this.style(), repaint = function () { if (!self.revealed) self.paint(); };
      var faces = [[st.fontStyle + st.weight + ' 32px ' + st.family, st.text]];
      if (st.mark) faces.push([st.mark.fontStyle + st.mark.weight + ' 32px ' + st.mark.family, st.mark.text]);
      for (var f = 0; f < faces.length; f++) {
        try { document.fonts.load(faces[f][0], faces[f][1]).then(repaint, function () {}); } catch (e) {}
      }
      if (document.fonts.ready) document.fonts.ready.then(repaint);
    }
    if (this.coverImg && !this.coverImg.complete) this.coverImg.addEventListener('load', function () { self.paint(); });

    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(function () { self.layout(); });
      this.ro.observe(card);
    }

    if (revealedKeys[this.key]) this.reveal(true);
    else this.addSheen();
  }

  var P = Scratch.prototype;

  P.style = function () {
    var cs = getComputedStyle(this.card);
    var ls = this.labelEl ? getComputedStyle(this.labelEl) : cs;
    var text = this.labelEl ? this.labelEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (ls.textTransform === 'uppercase') text = text.toUpperCase();
    var fsz = parseFloat(ls.fontSize) || 16, lsp = parseFloat(ls.letterSpacing);
    function v(name, fallback) { return (cs.getPropertyValue(name) || '').trim() || fallback; }
    function italic(st) { return st.fontStyle === 'italic' || st.fontStyle === 'oblique' ? 'italic ' : ''; }
    var mark = null;
    if (this.markEl) {
      var ms = getComputedStyle(this.markEl), mt = this.markEl.textContent.replace(/\s+/g, ' ').trim();
      if (ms.textTransform === 'uppercase') mt = mt.toUpperCase();
      var mfs = parseFloat(ms.fontSize) || 16, mls = parseFloat(ms.letterSpacing);
      if (mt) mark = { text: mt, family: ms.fontFamily || 'serif', weight: ms.fontWeight || '500', fontStyle: italic(ms), spacing: isNaN(mls) ? 0 : mls / mfs, label: v('--ks-mark', v('--ks-label', '#fff3cf')) };
    }
    return {
      a: v('--ks-cover-a', '#a2741f'),
      b: v('--ks-cover-b', '#dcb458'),
      c: v('--ks-cover-c', '#f6e3a1'),
      label: v('--ks-label', '#fff3cf'),
      text: text,
      family: ls.fontFamily || 'sans-serif',
      weight: ls.fontWeight || '700',
      fontStyle: italic(ls),
      mark: mark,
      goldA: v('--ks-gold-a', '#8c6a2a'),
      goldB: v('--ks-gold-b', '#c9a55a'),
      goldC: v('--ks-gold-c', '#f3e2a6'),
      spacing: isNaN(lsp) ? 0 : lsp / fsz,
      radius: parseFloat(cs.borderTopLeftRadius) || 0
    };
  };

  P.radius = function () {
    return Math.max(CONFIG.minBrush, Math.min(this.w, this.h) * CONFIG.brush);
  };

  P.layout = function (force) {
    var w = this.card.offsetWidth, h = this.card.offsetHeight;
    if (!w || !h) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (!force && w === this.w && h === this.h && dpr === this.dpr) return;
    this.w = w; this.h = h; this.dpr = dpr;
    this.canvas.width = Math.round(w * dpr);
    this.canvas.height = Math.round(h * dpr);
    if (this.dust) { this.dust.width = this.canvas.width; this.dust.height = this.canvas.height; }
    this.buildGrid();
    this.paint();
  };

  P.paint = function () {
    if (!this.w) return;
    var ctx = this.ctx;
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;
    ctx.clearRect(0, 0, this.w, this.h);
    this.palette = this.style();
    ctx.save();
    THEMES[this.theme](ctx, this.w, this.h, this.palette, this);
    ctx.restore();
    for (var i = 0; i < this.strokes.length; i++) this.drawSeg(this.strokes[i]);
  };

  P.buildGrid = function () {
    var cell = Math.max(5, Math.min(this.w, this.h) / 36);
    var cols = Math.ceil(this.w / cell), rows = Math.ceil(this.h / cell);
    var cells = new Uint8Array(cols * rows), total = 0, R = Math.min(this.w, this.h) / 2;
    for (var y = 0; y < rows; y++) {
      for (var x = 0; x < cols; x++) {
        var dx = (x + 0.5) * cell - this.w / 2, dy = (y + 0.5) * cell - this.h / 2;
        if (this.circle && dx * dx + dy * dy > R * R) cells[y * cols + x] = 2;
        else total++;
      }
    }
    this.grid = { cell: cell, cols: cols, rows: rows, cells: cells, total: total, hit: 0 };
    for (var i = 0; i < this.strokes.length; i++) this.mark(this.strokes[i]);
  };

  P.bind = function () {
    var self = this, c = this.canvas;
    function pos(e) {
      var rect = c.getBoundingClientRect();
      return { x: (e.clientX - rect.left) * (self.w / rect.width), y: (e.clientY - rect.top) * (self.h / rect.height) };
    }
    function feed(e) {
      var list = e.getCoalescedEvents ? e.getCoalescedEvents() : null;
      if (list && list.length) for (var i = 0; i < list.length; i++) self.move(pos(list[i]));
      else self.move(pos(e));
    }
    c.addEventListener('pointerdown', function (e) {
      if (self.revealed) return;
      self.down = true;
      self.last = null;
      try { c.setPointerCapture(e.pointerId); } catch (err) {}
      feed(e);
      e.preventDefault();
    });
    c.addEventListener('pointermove', function (e) {
      if (self.revealed) return;
      if (!self.down && !(CONFIG.mouseHover && e.pointerType === 'mouse')) return;
      feed(e);
    });
    function end() { self.down = false; self.last = null; }
    c.addEventListener('pointerup', end);
    c.addEventListener('pointercancel', end);
    c.addEventListener('pointerleave', function () { if (!self.down) self.last = null; });
    c.addEventListener('touchmove', function (e) { if (!self.revealed) e.preventDefault(); }, { passive: false });
  };

  P.move = function (p) {
    if (!this.w) return;
    var nx = p.x / this.w, ny = p.y / this.h;
    var seg = this.last ? [this.last[0], this.last[1], nx, ny] : [nx, ny, nx, ny];
    this.last = [nx, ny];
    if (this.sheen) this.dropSheen();
    this.strokes.push(seg);
    this.drawSeg(seg);
    this.mark(seg);
    this.shed(p, seg);
    this.check();
  };

  P.drawSeg = function (s) {
    var ctx = this.ctx, w = this.w, h = this.h, r = this.radius();
    var x0 = s[0] * w, y0 = s[1] * h, x1 = s[2] * w, y1 = s[3] * h;
    ctx.save();
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = r * 2;
    ctx.strokeStyle = ctx.fillStyle = '#000';
    ctx.beginPath();
    ctx.moveTo(x0, y0);
    ctx.lineTo(x1 + 0.01, y1);
    ctx.stroke();
    // Bords irréguliers, comme un vrai grattage
    var dx = x1 - x0, dy = y1 - y0, len = Math.sqrt(dx * dx + dy * dy);
    var n = Math.min(6, 2 + ((len / 8) | 0));
    for (var i = 0; i < n; i++) {
      var t = Math.random(), a = Math.random() * TAU, d = r * (0.85 + Math.random() * 0.3);
      ctx.beginPath();
      ctx.arc(x0 + dx * t + Math.cos(a) * d, y0 + dy * t + Math.sin(a) * d, 1 + Math.random() * r * 0.2, 0, TAU);
      ctx.fill();
    }
    ctx.restore();
  };

  P.mark = function (s) {
    var g = this.grid, r = this.radius() * 0.9, r2 = r * r, w = this.w, h = this.h;
    var x0 = s[0] * w, y0 = s[1] * h, dx = s[2] * w - x0, dy = s[3] * h - y0;
    var steps = Math.max(1, Math.ceil(Math.sqrt(dx * dx + dy * dy) / (g.cell * 0.5)));
    for (var k = 0; k <= steps; k++) {
      var px = x0 + dx * k / steps, py = y0 + dy * k / steps;
      var c0 = Math.max(0, Math.floor((px - r) / g.cell)), c1 = Math.min(g.cols - 1, Math.floor((px + r) / g.cell));
      var r0 = Math.max(0, Math.floor((py - r) / g.cell)), r1 = Math.min(g.rows - 1, Math.floor((py + r) / g.cell));
      for (var row = r0; row <= r1; row++) {
        for (var col = c0; col <= c1; col++) {
          var idx = row * g.cols + col;
          if (g.cells[idx]) continue;
          var ex = (col + 0.5) * g.cell - px, ey = (row + 0.5) * g.cell - py;
          if (ex * ex + ey * ey <= r2) { g.cells[idx] = 1; g.hit++; }
        }
      }
    }
  };

  P.check = function () {
    var ratio = this.grid.total ? this.grid.hit / this.grid.total : 0;
    if (ratio !== this.ratio) {
      this.ratio = ratio;
      fire(this.card, 'ks:progress', { ratio: ratio });
    }
    if (!this.revealed && ratio >= CONFIG.threshold) this.reveal();
  };

  /* Copeaux de grattage qui tombent */
  P.shed = function (p, seg) {
    if (!this.dust || this.particles.length > 140) return;
    var pal = this.palette, leaf = !!this.fx.leaf, cols = leaf ? [pal.goldA, pal.goldB, pal.goldC, pal.b] : [pal.a, pal.b, pal.c];
    var moved = Math.abs(seg[2] - seg[0]) + Math.abs(seg[3] - seg[1]);
    var n = moved > 0.004 ? 2 : 1;
    for (var i = 0; i < n; i++) {
      this.particles.push({
        x: p.x + (Math.random() - 0.5) * this.radius(),
        y: p.y + (Math.random() - 0.5) * this.radius(),
        vx: (Math.random() - 0.5) * 1.6,
        vy: -Math.random() * 1.2,
        s: 1 + Math.random() * 2.6,
        rot: Math.random() * TAU,
        vr: (Math.random() - 0.5) * 0.4,
        life: 1,
        leaf: leaf,
        color: cols[(Math.random() * cols.length) | 0]
      });
    }
    if (!this.dustRaf) this.tickDust();
  };

  P.tickDust = function () {
    var self = this, ctx = this.dctx;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.dust.width, this.dust.height);
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    for (var i = this.particles.length - 1; i >= 0; i--) {
      var q = this.particles[i];
      q.vy += 0.22; q.x += q.vx; q.y += q.vy; q.rot += q.vr; q.life -= 0.018;
      if (q.life <= 0 || q.y > this.h + 10) { this.particles.splice(i, 1); continue; }
      ctx.save();
      ctx.globalAlpha = Math.min(1, q.life * 1.5);
      ctx.translate(q.x, q.y);
      ctx.rotate(q.rot);
      ctx.fillStyle = q.color;
      if (q.leaf) {
        ctx.scale(1, Math.cos(q.rot * 2));
        ctx.beginPath();
        ctx.moveTo(0, -q.s * 0.6); ctx.lineTo(q.s * 0.5, 0); ctx.lineTo(0, q.s * 0.5); ctx.lineTo(-q.s * 0.6, -q.s * 0.1);
        ctx.closePath();
        ctx.fill();
      } else {
        ctx.fillRect(-q.s / 2, -q.s / 3, q.s, q.s * 0.66);
      }
      ctx.restore();
    }
    this.dustRaf = this.particles.length ? requestAnimationFrame(function () { self.tickDust(); }) : 0;
  };

  /* Reflet lumineux qui balaie le calque tant que personne n'a gratté */
  P.addSheen = function () {
    var on = CONFIG.sheen === 'auto' ? !!this.fx.sheen : !!CONFIG.sheen;
    if (!on || reduceMotion || this.sheen || this.revealed) return;
    // La bande est un <span> et l'affichage est forcé : certains thèmes Shopify
    // (Dawn et ses dérivés) masquent les div vides avec « div:empty { display: none } ».
    var wrap = document.createElement('div'), bar = document.createElement('span');
    wrap.className = 'ks-sheen';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:4;pointer-events:none;overflow:hidden;border-radius:inherit;transition:opacity .4s ease';
    bar.style.cssText = 'display:block;position:absolute;top:-60%;left:0;width:38%;height:220%;background:linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.6) 50%,rgba(255,255,255,0));mix-blend-mode:soft-light;transform:translateX(-160%) rotate(18deg)';
    wrap.style.setProperty('display', 'block', 'important');
    bar.style.setProperty('display', 'block', 'important');
    wrap.appendChild(bar);
    this.card.appendChild(wrap);
    this.sheen = wrap;
    if (bar.animate) {
      this.sheenAnim = bar.animate([
        { transform: 'translateX(-160%) rotate(18deg)', offset: 0 },
        { transform: 'translateX(-160%) rotate(18deg)', offset: 0.4, easing: 'cubic-bezier(.45,0,.2,1)' },
        { transform: 'translateX(330%) rotate(18deg)', offset: 0.78 },
        { transform: 'translateX(330%) rotate(18deg)', offset: 1 }
      ], { duration: 4200, iterations: Infinity });
    }
  };

  P.dropSheen = function () {
    var el = this.sheen, anim = this.sheenAnim;
    if (!el) return;
    this.sheen = this.sheenAnim = null;
    el.style.opacity = '0';
    setTimeout(function () { if (anim) anim.cancel(); if (el.parentNode) el.parentNode.removeChild(el); }, 450);
  };

  P.lockClaim = function () {
    for (var i = 0; i < this.claims.length; i++) {
      this.claims[i].classList.add('ks-claim-anim');
      this.claims[i].classList.add('ks-claim-locked');
    }
  };

  P.reveal = function (instant) {
    if (this.revealed) return;
    this.revealed = true;
    revealedKeys[this.key] = true;
    var card = this.card;
    if (instant) card.classList.add('ks-instant');
    card.classList.add('is-revealed');
    if (this.prizeEl) this.prizeEl.removeAttribute('aria-hidden');
    for (var i = 0; i < this.claims.length; i++) this.claims[i].classList.remove('ks-claim-locked');
    var cv = this.canvas;
    this.hideTimer = setTimeout(function () { cv.style.display = 'none'; }, instant ? 0 : 700);
    this.dropSheen();
    if (!instant && CONFIG.confetti && !reduceMotion) confetti(card, this.palette, !!this.fx.leaf);
    fire(card, 'ks:revealed', { ratio: this.ratio });
    try { window.dispatchEvent(new CustomEvent('ksScratchRevealed', { detail: { card: card } })); } catch (e) {}
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'ks_scratch_revealed' });
  };

  P.reset = function () {
    delete revealedKeys[this.key];
    clearTimeout(this.hideTimer);
    this.canvas.style.display = '';
    this.revealed = false;
    this.strokes = [];
    this.last = null;
    this.ratio = 0;
    this.card.classList.remove('is-revealed', 'ks-instant');
    if (this.prizeEl) this.prizeEl.setAttribute('aria-hidden', 'true');
    this.claims = findClaims(this.card);
    this.lockClaim();
    this.buildGrid();
    this.paint();
    this.addSheen();
    fire(this.card, 'ks:progress', { ratio: 0 });
  };

  P.destroy = function () {
    this.dropSheen();
    if (this.ro) this.ro.disconnect();
    if (this.dustRaf) cancelAnimationFrame(this.dustRaf);
  };

  /* ---------------------------------------------------------------------
     Aides
     --------------------------------------------------------------------- */

  function fire(el, name, detail) {
    try { el.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true })); } catch (e) {}
  }

  /* Le bouton CLAIM est ailleurs dans le formulaire : on remonte depuis la
     carte jusqu'au premier ancêtre qui le contient. */
  function findClaims(card) {
    var el = card.parentElement;
    while (el && el !== document.documentElement) {
      var hits = el.querySelectorAll(CONFIG.claimSelector);
      if (hits.length) return Array.prototype.slice.call(hits);
      el = el.parentElement;
    }
    return [];
  }

  var cursorCache = null;
  function coinCursor() {
    if (!cursorCache) {
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">' +
        '<defs><radialGradient id="g" cx="40%" cy="35%" r="70%"><stop offset="0" stop-color="#fbe7a1"/><stop offset=".6" stop-color="#d4a441"/><stop offset="1" stop-color="#8a6220"/></radialGradient></defs>' +
        '<circle cx="16" cy="16" r="13" fill="url(#g)" stroke="#6b4a14" stroke-width="1.5"/>' +
        '<circle cx="16" cy="16" r="9" fill="none" stroke="#6b4a14" stroke-opacity=".45"/>' +
        '<path d="M16 10.5l1.6 3.4 3.7.4-2.8 2.5.8 3.7-3.3-1.9-3.3 1.9.8-3.7-2.8-2.5 3.7-.4z" fill="#6b4a14" fill-opacity=".55"/></svg>';
      cursorCache = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '") 16 16, pointer';
    }
    return cursorCache;
  }

  function confetti(card, pal, leaf) {
    var rect = card.getBoundingClientRect();
    var cv = document.createElement('canvas');
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = window.innerWidth, H = window.innerHeight;
    cv.width = W * dpr; cv.height = H * dpr;
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:2147483647';
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), bits = [];
    var cols = leaf ? [pal.goldA, pal.goldB, pal.goldC, '#fff3cf', pal.goldB] : [pal.b, pal.c, '#ffffff', pal.a, '#3dd6f5'];
    var ox = rect.left + rect.width / 2, oy = rect.top + rect.height / 2;
    for (var i = 0; i < (leaf ? 110 : 90); i++) {
      var a = -Math.PI / 2 + (Math.random() - 0.5) * 2.6, sp = 5 + Math.random() * 9;
      bits.push({ x: ox + (Math.random() - 0.5) * rect.width * 0.5, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, w: 4 + Math.random() * 5, h: 2 + Math.random() * 4, r: Math.random() * TAU, vr: (Math.random() - 0.5) * 0.3, c: cols[i % cols.length], ph: Math.random() * TAU });
    }
    var start = null;
    function frame(t) {
      if (start === null) start = t;
      var el = t - start;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = Math.max(0, 1 - Math.max(0, el - 900) / 700);
      for (var j = 0; j < bits.length; j++) {
        var b = bits[j];
        b.vy += leaf ? 0.2 : 0.28; b.vx *= 0.985; b.x += b.vx + (leaf ? Math.sin(el * 0.006 + b.ph) * 0.9 : 0); b.y += b.vy; b.r += b.vr;
        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.rotate(b.r);
        ctx.scale(1, Math.cos(b.r * 2));
        ctx.fillStyle = b.c;
        if (leaf) {
          ctx.beginPath();
          ctx.moveTo(-b.w * 0.6, -b.h * 0.2); ctx.lineTo(b.w * 0.1, -b.h * 0.7); ctx.lineTo(b.w * 0.6, b.h * 0.1); ctx.lineTo(-b.w * 0.1, b.h * 0.6);
          ctx.closePath();
          ctx.fill();
        } else {
          ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h);
        }
        ctx.restore();
      }
      if (el < 1600) requestAnimationFrame(frame);
      else if (cv.parentNode) cv.parentNode.removeChild(cv);
    }
    requestAnimationFrame(frame);
  }

  /* ---------------------------------------------------------------------
     Détection des cartes : Klaviyo injecte la popup après le chargement de
     la page, on surveille donc le DOM et l'événement « klaviyoForms ».
     --------------------------------------------------------------------- */

  function instanceOf(el) {
    for (var i = 0; i < live.length; i++) if (live[i].card === el) return live[i];
    return null;
  }

  function scan() {
    for (var i = live.length - 1; i >= 0; i--) {
      if (!document.documentElement.contains(live[i].card)) { live[i].destroy(); live.splice(i, 1); }
    }
    var list = document.querySelectorAll(CONFIG.selector);
    for (var j = 0; j < list.length; j++) {
      if (instanceOf(list[j])) continue;
      try { live.push(new Scratch(list[j])); }
      catch (err) { if (window.console) console.warn('[ks-scratch]', err); }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 16);
  }

  if (CONFIG.fontsUrl && document.head && !document.querySelector('link[data-ks-fonts]')) {
    var fl = document.createElement('link');
    fl.rel = 'stylesheet';
    fl.href = CONFIG.fontsUrl;
    fl.setAttribute('data-ks-fonts', '');
    document.head.appendChild(fl);
  }
  if (window.MutationObserver) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('klaviyoForms', schedule);
  if (!window.ResizeObserver) window.addEventListener('resize', function () { for (var i = 0; i < live.length; i++) live[i].layout(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  /* API publique (utile pour les tests) */
  window.KsScratch = {
    version: '1.3',
    config: CONFIG,
    scan: scan,
    get: instanceOf,
    reset: function (el) { var x = el ? instanceOf(el) : null; if (x) x.reset(); else for (var i = 0; i < live.length; i++) live[i].reset(); },
    reveal: function (el) { var x = instanceOf(el); if (x) x.reveal(); },
    refresh: function () { for (var i = 0; i < live.length; i++) if (!live[i].revealed) live[i].paint(); }
  };
})();
